import { Node, NodeSpec } from 'prosemirror-model';

export const paragraph: NodeSpec = {
  group: 'block',
  content: 'inline*',
  parseDOM: [{ tag: 'p' }],
  toDOM: () => ['p', 0],
  dragHandle: true,
}

export const isParagraph = (node: Node) => node.type.spec === paragraph;
